export const maintenanceScreenWeb = 'maintenance_screen_web'
export const trustThisDeviceWeb = 'trust_this_device_web'
export const a4Login = 'a4_login_redesign'
export const emailSuspensionNotification = 'email_suspension_notification'
export const resetPasswordMigration = 'reset_password_migration'
export const jwtAuthenticationWeb = 'jwt_authentication_web'
